<template>
  <div>
    <v-dialog v-model="showModalFamilia" max-width="600">
      <v-card>
        <v-card-title class="headline">Questionários disponíveis para responder</v-card-title>
        <v-card-text>
          <div v-if="questionarioFamilia.length === 0" class="text-center red--text font-weight-bold">
            Nenhum questionário disponível
          </div>
          <v-list v-else>
            <v-list-item
              @click="selecionarQuetionariInstituicao(item)"
              v-for="item in questionarioFamilia.filter((i) => i && i.instituicao)"
              :key="item.cgm"
            >
              <v-list-item-content>
                <div><strong>Nome:</strong> {{ item.nome }}</div>

                <div style="padding: 8px; background-color: green; color: #fff">
                  <strong>Clique aqui Para responder : {{ item.instituicao }}</strong>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="1 != 1" color="primary" @click="showModalFamilia = false">Não Vou Responder Agora</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card class="pa-6 mt-5" max-width="400" outlined>
      <v-card-title class="headline">Validação de Usuário</v-card-title>
      <v-card-text>
        <v-text-field
          v-model="identificacao"
          :label="validarAluno ? 'CGM' : 'CPF'"
          :maxlength="validarAluno ? 20 : 14"
          outlined
          dense
          prepend-icon="mdi-card-account-details-outline"
          @keyup.enter="validarUsuario"
          :placeholder="validarAluno ? 'CGM do aluno' : '000.000.000-00'"
          :disabled="loading"
        />
        <v-btn
          color="primary"
          block
          :loading="loading"
          @click="validarUsuario"
          :disabled="!identificacao || (validarAluno ? identificacao.length < 5 : identificacao.length < 11)"
        >
          Validar
        </v-btn>
        <v-alert v-if="mensagem" :type="mensagemTipo" class="mt-4" dense>
          {{ mensagem }}
        </v-alert>
      </v-card-text>
    </v-card>
    <!-- Modal removido, voltando ao estado anterior -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "ValidaUsuarioQuestionario",
  data() {
    return {
      tipo: "CPF",
      tipos: ["CPF", "CGM"],
      identificacao: "",
      loading: false,
      mensagem: "",
      mensagemTipo: "info",
      questionarioFamilia: [],
      showModalFamilia: false,
    };
  },
  computed: {
    ...mapGetters({ param: "avaliacao/param", processo: "remocao/processoSelecionado" }),
    validarAluno() {
      let v = false;
      if (this.param.Selecionado.alunos == 1) {
        v = true;
      }
      return v;
    },
  },
  methods: {
    ...mapMutations({ setPessoa: "avaliacao/setPessoa" }),
    ...mapActions("avaliacao", ["requestValidar"]),
    async validarUsuario() {
      this.mensagem = "";
      let payload = {};
      if (this.validarAluno) {
        if (!this.identificacao || this.identificacao.trim().length < 5) {
          this.mensagem = "CGM inválido!";
          this.mensagemTipo = "error";
          return;
        }
        payload.cgm = this.identificacao;
      } else {
        const cpfNumeros = this.identificacao.replace(/\D/g, "");
        if (cpfNumeros.length !== 11) {
          this.mensagem = "CPF inválido!";
          this.mensagemTipo = "error";
          return;
        }
        payload.cpf = cpfNumeros;
      }
      this.loading = true;
      try {
        if (this.validarAluno) {
          payload.cpf = null;
        } else {
          payload.cgm = null;
        }
        payload.id_questionario = this.param.Selecionado.id;
        //this.param.Selecionado

        payload.id_processo = this.processo ? this.processo.id : null;
        if (!payload.id_processo) {
          this.$router.push({ name: "initPage" });
        }
        console.log("enviando....", payload);
        const resp = await this.requestValidar(payload);
        if (resp && resp.data && resp.data.success) {
          if (Number(this.param.Selecionado.id_publico) == 2) {
            this.questionarioFamilia = resp.data.data.filter((item) => item.respondido == 0);
            this.showModalFamilia = true;
          }
          if (Number(this.param.Selecionado.id_publico) == 1) {
            this.mensagem = "Usuário validado! Você pode responder o questionário.";
            this.mensagemTipo = "success";
            this.setPessoa(resp.data.data[0]);
            this.$router.push({ name: "questionario" });
          }

          if (Number(this.param.Selecionado.id_publico) > 2) {
            this.questionarioFamilia = resp.data.data.filter((item) => item.respondido == 0);
            this.showModalFamilia = true;
          }
        }
        if (resp.data.error) {
          this.mensagem = resp.data.error;
          this.mensagemTipo = "warning";
        }
      } catch (e) {
        this.mensagem = "Erro ao validar usuário.";
        this.mensagemTipo = "error";
      } finally {
        this.loading = false;
      }
    },
    selecionarQuetionariInstituicao(item) {
      this.setPessoa(item);
      this.$router.push({ name: "questionario" });
    },
  },
  mounted() {
    // Se não houver questionário selecionado, redireciona para seleção
    const id = this.param?.Selecionado?.id;
    if (!id || id === 0 || id === "0" || typeof id === "undefined" || id === null) {
      this.$router.push({ name: "homeAvaliacao" });
    }
  },
};
</script>

<style scoped></style>
